module.exports = __webpack_public_path__ + "static/sport/h5Bg.0a608cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/h5Bg.png
// module id = sXJa
// module chunks = 0